<template>
  <div>
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="container">
        <div class="alert alert-primary text-center" role="alert">
          <b class="fs-4">내 부 공 지 리 스 트</b>
        </div>        
        <div class="alert alert-info" role="alert">
          ※ 공지상태 Y 중, 최근 작성내용이 공지됩니다. ※
        </div>
        <div class="float-end mb-1">
          <button type="button" class="btn btn-success" @click="goToInsert">공지등록</button>
        </div>
        <table class="tb_notice table table-bordered table-striped">
          <thead>
            <tr>
              <th>공지제목</th>
              <th>등록일</th>
              <th>공지상태</th>
              <th>상태변경</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="i" v-for="(notice, i) in noticeList">
              <td>
                <a @click="goToNoticeDetail(notice.seqNotice);" style="cursor:pointer;"><span class="text-primary">{{ notice.nTitle }}</span></a>
              </td>
              <td>{{ this.getDateFormat(notice.insDate) }}</td>
              <td>{{ notice.nUseFlag }}</td>
              <td>
                <button type="button" class="btn btn-warning btn-sm" @click="changeStatus(notice.nUseFlag, notice.seqNotice)">변경</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //productMaList: [],
      noticeList: [],
      companyInfo: []
    };
  },
  created() {
    this.productId = this.$route.query.productId;
    this.getNoticeList();
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 5) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/b2bLogin'});
    }
    document.getElementById("user").style.display = "none";    
  },
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    async getNoticeList() {
      let noticeList = await this.$api("/api/notice_ma_list", {});
      if(noticeList.length > 0)
      {
        this.noticeList = noticeList
      }
      console.log("noticeList:",this.noticeList);
    },
    goToInsert() {
      this.$router.push({path: '/ma_noticeCreate'});
    },
    goToNoticeDetail(seqNotice) {
      this.$router.push({path: '/ma_NoticeDetail', query: {seqNotice: seqNotice}});
    },
    // mixins에 있는 공통함수 호출샘플
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    changeStatus(nUseFlag, seqNotice) {
      //변경전 확인
      this.$swal.fire({
        title: '공지상태(실행<->중지)변경?',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let nStatus = (nUseFlag == "Y") ? "N" : "Y"
          await this.$api("/api/changeNoticeStatus_ma", {param: [nStatus, seqNotice]});
          // 상태변경 후, 갱신
          this.getNoticeList();
          this.$swal.fire('','변경완료!', 'success')
        }
      })
    }
  }
}
</script>

<style scoped>
.tb_notice th {
  text-align: center;
  font-weight: bold;
  font-size: 1.1rem;
}
.tb_notice td {
  text-align: center;
  font-size: 1rem;
}
</style>